import axios from "axios";
import { SignupAuthModel } from "../../datamodels/auth/signupAuthModel";
import { OTPResponse, SignUpModel } from "../../datamodels/auth/signUpModel";

export async function sendSignUpApiCallEmail(
  passedUsername: null,
  passedEmail: String,
  passedPassword: null
) {
  const response = await axios.post<SignUpModel>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/register`,

    `/user/Auth/v2/SignUp`,
    {
      userName: passedUsername,
      password: passedPassword,
      email: passedEmail,
      actionMedium: false,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}
export async function sendSignUpApiCallPhone(
  passedPhoneNumber: String,
  countryCode?: String
) {
  const response = await axios.post<SignUpModel>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/register`,
    // `${process.env.REACT_APP_BASE_URL}/user/Auth/v2/SignUp`,
    `/user/Auth/signup/link/phone`,
    {
      mobileNo: passedPhoneNumber,
      // password: passedPassword,
      // userName: passedUsername,
      // actionMedium: true,
      countryCode: countryCode,
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}

export async function verifyOTP(OTP: string, profileId: string) {
  const response = await axios.post<SignupAuthModel>(
    `/user/Auth/signup/verify/login`,
    {
      profileId: profileId,
      otp: OTP,
      deviceInfo: {
        notificationId: "test",
        appVersion: "1.9.2.1",
        appOS: "iOS",
      },
    },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}

export async function resendOTP(profileId: string) {
  const response = await axios.post<OTPResponse>(
    // `${process.env.REACT_APP_BASE_URL}v1/auth/resendotp`,
    `/user/Auth/ResendOTP`,
    { profileId: profileId },
    {
      headers: {
        "Basic-Auth": process.env.REACT_APP_BASIC_AUTH,
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.responseInfo.httpCode === 200) {
    return response.data;
  } else {
    return response.data;
  }
}
